import { render, staticRenderFns } from "./FiltersToggle.vue?vue&type=template&id=8ff230f4&scoped=true"
import script from "./FiltersToggle.vue?vue&type=script&lang=js"
export * from "./FiltersToggle.vue?vue&type=script&lang=js"
import style0 from "./FiltersToggle.vue?vue&type=style&index=0&id=8ff230f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff230f4",
  null
  
)

export default component.exports